import type { ObjectView, TableModel } from '../model/table';

/** Only facts already present in this seat's validated observation are rendered. */
export function PublicProgress({ object, table }: { object: ObjectView; table: TableModel }) {
  const rows = table.seats.flatMap(seat => {
    const value = object.fields[`progress.${seat.id}`];
    if (typeof value !== 'string') return [];
    return [{ id: seat.id, label: seat.label, text: value, met: object.fields[`qualifies.${seat.id}`] === true }];
  });
  const holder = object.owner ?? (typeof object.fields.claimedBy === 'string' ? object.fields.claimedBy : null);
  const holderLabel = holder ? table.seats.find(seat => seat.id === holder)?.label ?? holder.replace(/(^|[-_ ])([a-z])/g, (_, gap: string, letter: string) => `${gap ? ' ' : ''}${letter.toUpperCase()}`) : null;
  return rows.length ? <div className="public-progress" aria-label="Public prerequisite progress">
    {holderLabel && <p><strong>Claimed by {holderLabel}</strong></p>}
    <p>Public prerequisite progress</p>
    {rows.map(row => <div key={row.id} className={row.met ? 'requirements-met' : ''}>
      <strong>{row.label}</strong><span>{row.text}</span><small>{row.met ? 'Prerequisites met' : 'Not yet met'}</small>
    </div>)}
    <p>Claiming also requires a legal worker placement and payment.</p>
  </div> : null;
}
